import { PurchaseChannel } from "@redotech/redo-model/warranties";
import { memo } from "react";
import { OneTimePasscode } from "./one-time-passcode";
const purchaseChannelToTitle: Record<PurchaseChannel, string> = {
  [PurchaseChannel.ONLINE]: "Let's find your order",
  [PurchaseChannel.RETAIL]: "Let's verify your email",
};

const purchaseChannelToNextUrl: Record<PurchaseChannel, string> = {
  [PurchaseChannel.ONLINE]: "/returns-portal/orders/register",
  [PurchaseChannel.RETAIL]: "/returns-portal/register/retail",
};

export const RegisterOtp = memo(function RegisterOtp({
  onBack,
  purchaseChannel,
}: {
  onBack: () => void;
  purchaseChannel: PurchaseChannel | undefined;
}) {
  if (!purchaseChannel) {
    return null;
  }
  return (
    <OneTimePasscode
      nextUrl={purchaseChannelToNextUrl[purchaseChannel]}
      onBack={onBack}
      showFooter={false}
      showLogo={false}
      title={purchaseChannelToTitle[purchaseChannel]}
    />
  );
});
